import { useState } from 'react';

import { IntroducingQuickPlayDialog } from './IntroducingQuickPlayDialog';
import { ScoringDialog } from './ScoringDialog';
import { TargetDialog } from './TargetDialog';
import type { QuickPlayTutorialDialogType } from './types';

type Props = {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
};
export const QuickPlayTutorialDialog = ({
  open,
  onClose,
  loading = false,
}: Props) => {
  const [displayedDialog, setdisplayedDialog] = useState<
    'quickPlay' | 'targets' | 'scoring'
  >('quickPlay');

  const [hasSeenDialog, setHasSeenDialog] = useState(false);

  const onSelect = (type: QuickPlayTutorialDialogType) => {
    setdisplayedDialog(type);
    setHasSeenDialog(true);
  };

  if (displayedDialog === 'quickPlay') {
    return (
      <IntroducingQuickPlayDialog
        open={open}
        onContinue={onClose}
        loading={loading}
        onSelect={onSelect}
        disableAnimation={hasSeenDialog}
      />
    );
  }

  if (displayedDialog === 'targets') {
    return (
      <TargetDialog
        open={open}
        onContinue={onClose}
        loading={loading}
        onSelect={onSelect}
      />
    );
  }

  return (
    <ScoringDialog
      open={open}
      onContinue={onClose}
      loading={loading}
      onSelect={onSelect}
    />
  );
};
